import { CreateEvaluationDto, Evaluation, EvaluationDetails } from "@/types";
import { apiClient } from "./api";

export const evaluationsApi = {
  list: () => apiClient.get<Evaluation[]>("/eval/api/evaluations"),

  create: (data: CreateEvaluationDto) =>
    apiClient.post<{ id: string; message: string }>(
      "/eval/api/evaluations",
      data,
    ),

  get: (id: string) =>
    apiClient.get<EvaluationDetails>(`/eval/api/evaluations/${id}`),
};
